// extracted by mini-css-extract-plugin
export default {"ConsolidatedShippingCallout__link":"ConsolidatedShippingCallout-styles__ConsolidatedShippingCallout__link__yUGpZ"};